import React from "react";
import VerificationCompleted from "../VerificationCompleted/VerificationCompleted";

const PaymentSuccess = () => {
  return <VerificationCompleted message={"Payment Successful"} />;
};

export default PaymentSuccess;
